<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
        <!-- mainTable Start -->
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <th v-show="editMode" width="20">
                        </th>
                        <th v-show="editMode" width="20">EDIT</th>
                        <th> NAME </th>
                        <th> LANGUAGE </th>
                        <th v-show="viewMode"> CREATED </th>
                        <th v-show="viewMode"> UPDATED </th>
                        <th v-show="viewMode"> CREATED BY </th>
                        <th v-show="viewMode"> UPDATED BY </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(excel, i) in CADMANUAL" :key="i">
                        <td v-show="editMode">
                            <v-checkbox v-model="excel.selected" dense></v-checkbox>
                        </td>
                        <td v-show="editMode"> 
                            <v-btn
                                fab
                                x-small
                                @click="toggleUpdateDialog(excel)"
                            >
                                <v-icon >mdi-pencil</v-icon> 
                            </v-btn>
                        </td>
                        <td> {{ excel.filename }} </td>
                        <td> {{ excel.language == 2 ? 'JAPANESE' : excel.language == 1 ? 'ENGLISH'  : null}} </td>
                        <td v-show="viewMode"> {{ formatDate(excel.created_at) }} </td>
                        <td v-show="viewMode"> {{ formatDate(excel.updated_at) }} </td>
                        <td v-show="viewMode"> {{ excel.created_by }} </td>
                        <td v-show="viewMode"> {{ excel.updated_by }} </td>
                    </tr>
                </tbody>
            </v-simple-table>
        <!-- mainTable End -->

            
        </v-container>

        <!-- Dialogs -->
        <!-- dialogStore Start -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title> <span class="overline">Upload New Manual</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <!-- <v-file-input
                                        outlined 
                                        dense 
                                        label="CAD Request File(Excel)"
                                        name="name" 
                                        class="required"
                                    > </v-file-input> -->
                                        <!-- :rules="rules.uniqueRemarks(REMARKS)" -->
                                <v-file-input
                                    prepend-icon=""
                                    outlined
                                    dense
                                    chips
                                    clearable
                                    v-model="fileAttachments"
                                    density="compact"
                                    label="CAD Request Manual"
                                    @change="fileChange(fileAttachments)"
                                    ></v-file-input>
                                <v-select 
                                    label="Language"
                                    outlined
                                    dense
                                    density="compact"
                                    v-model="language"
                                    :items="languageSelection" 
                                    item-value="value"
                                    item-text="text"
                                ></v-select>
                                </v-col>
                            </v-row>
                            <!-- <v-row>
                                <v-col cols="12">
                                    <v-select 
                                        label="Language"
                                        outlined
                                        dense
                                        density="compact"
                                        :items="languageSelection" 
                                        item-value="value"
                                        item-text="text"
                                    ></v-select>
                                </v-col>
                            </v-row> -->
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogStore End -->

        <!-- dialogUpdate Update -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title> <span class="overline">Edit Files</span> </v-card-title>
                        <v-card-text>
                            <!-- <v-row>
                                <v-col cols="2">
                                    <v-icon>mdi-playlist-edit</v-icon>
                                </v-col>
                                <v-col>
                                    <span class="text-center"><b>{{tempData.filename}}</b></span>
                                </v-col>
                            </v-row> -->
                            <v-row>
                                <v-col cols="12">
                                    <v-file-input
                                        v-model="tempData.file"
                                        prepend-icon=""
                                        outlined
                                        dense
                                        chips
                                        clearable
                                        label="CAD Request Manual"
                                        @change="fileChange(tempData.file)"
                                    > </v-file-input>
                                    <v-select 
                                        label="Language"
                                        outlined
                                        dense
                                        density="compact"
                                        v-model="tempData.language"
                                        @change="getLanguage(tempData.language)"
                                        :items="languageSelection" 
                                        item-value="value"
                                        item-text="text"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogUpdate End -->

        <!-- dialogDelete Start -->
        <v-dialog v-model="dialogDelete" max-width="300" persistent>
            <v-form id="Delete" ref="Delete" @submit.prevent="Delete">
                <v-card>
                    <v-card-title> <span class="overline">delete</span> </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="overline font-weight-black"> Delete Selected Items? </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogDelete = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogDelete End -->

        <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons>
        <app-footer :items="CADMANUAL.length"></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
    export default {
        components: {
            'app-toolbar': ToolbarMenu,
            'app-buttons': FloatingButtons,
            'app-footer': Footer
        },
        data: () => ({
            toolbar: {
                title: 'CAD Request Manual',
                view: true,
                back: true,
                filter: false,
                master: false,
            },

            floatButtons:{
                add: true,
                update: true,
                delete: true
            },
            language: null,

            tempData: {},
            
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false,

            file: [],
            fileAttachments: null,
            languageSelection: [
                {
                    text: 'English',
                    value: 1
                },
                {
                    text: 'Japanese',
                    value: 2
                }
            ]


        }),

        computed : {
            ...mapState([
                'CADMANUAL',
                'rules',
                'viewMode',
                'editMode'
            ]),

            selectedData(){
                // this will return only the id of the selected data
                return this.CADMANUAL.filter(res => res.selected).map(res => res.id); 
            }
        },

        methods: {
            ...mapActions([
                '_getManual',
            ]),
            getLanguage(lang){
                this.tempData.language = null;
                if(lang) this.tempData.language = lang;
            },

            fileChange(tempVariable){
                // return console.log(tempVariable)
                this.file = [];
                if(tempVariable){
                    // tempVariable.forEach(async (item) => {
                        // let splitFile = tempVariable.name.split('.')
                        // if(splitFile[splitFile.length - 1] == 'xls' || splitFile[splitFile.length - 1] == 'xlsx'){
                            // numPages = await getNumPages(tempVariable);
                            // numPages = numPages.length;
                        // }
                        const reader = new FileReader();
                        reader.readAsDataURL(tempVariable);
                        reader.onloadend = () => {
                            this.file.push({
                                data: reader.result,
                                name: tempVariable.name,
                            });
                        };
                    // })
                    console.log(this.file, 'this.file')
                }

            },

            formatDate(val){
                return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false })
            },

            toggleDialogStore(val){
                this.dialogStore = val;
            },

            Store(){
                if(this.$refs.Store.validate()){
                    const myForm = document.getElementById('Store');
                    const formdata = new FormData(myForm);
                    formdata.append("file", JSON.stringify(this.file));
                    formdata.append("language", JSON.stringify(this.language));

                    axios({
                        method: 'POST',
                        url: '/api/cad_manual/store',
                        data: formdata
                    }).then(() => {
                        this._getManual();
                        this.dialogStore = false;
                    })
                }
            },

            toggleUpdateDialog(item){
                if(item){
                    this.tempData = {...item};
                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

            Update(){
                if(this.$refs.Update.validate()){
                    const myForm = document.getElementById('Update');
                    const formdata = new FormData(myForm);
                    formdata.append("file", JSON.stringify(this.file))
                    formdata.append("data", JSON.stringify(this.tempData));
                    const id = this.tempData.id

                    axios({
                        method: 'POST',
                        url: `/api/cad_manual/update/${id}`,
                        data: formdata
                    }).then(() => {
                        this._getManual();
                        this.dialogUpdate = false;
                    })
                }
            },

            
            toggleDialogDelete(val){
                this.dialogDelete = val;
            },

            Delete(){
                axios({
                    method: 'POST',
                    url: '/api/cad_manual/delete',
                    data: {ids : this.selectedData}
                }).then(() => {
                    this._getManual();
                    this.dialogDelete = false;
                })
            }
        },

        mounted() {
            this._getManual();
        },

        watch:{
            dialogStore(value){
                if( ! value ) this.$refs.Store.reset();
            },

            dialogUpdate(value){
                if( ! value ) this.$refs.Update.reset();
            },

        }
    }
</script>

<style scoped>


</style>